module.exports = __webpack_public_path__ + "img/icon_赛事等级徽章_C级@3x.4dec9704.png";